import { render } from "./ReportReceived.vue?vue&type=template&id=d16b18bc"
import script from "./ReportReceived.vue?vue&type=script&lang=js"
export * from "./ReportReceived.vue?vue&type=script&lang=js"

import "./ReportReceived.vue?vue&type=style&index=0&id=d16b18bc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__